import { Component, OnInit } from '@angular/core';
import { DefaultAppSettingService } from '../../services/default-app-setting.service';
import { FullSpinnerService } from '../../services/full-spinner.service';
import { DefaultAppSetting } from '../../models/DefaultAppSetting';
import { CommonModule } from '@angular/common';
import { HasPermissionDirective } from '../../utils/has-permission.directive';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AppConstants } from '../../utils/AppConstants';
import { AlertService } from '../shared/alert/alert.service';
import { AppEnums } from '../../models/AppEnums';

@Component({
  selector: 'app-default-app-setting',
  standalone: true,
  imports: [CommonModule, HasPermissionDirective, FormsModule, ReactiveFormsModule],
  templateUrl: './default-app-setting.component.html',
  styleUrl: './default-app-setting.component.scss'
})
export class DefaultAppSettingComponent implements OnInit {

  defaultAppSettings: DefaultAppSetting[] = [];
  groupedDefaultAppSettings: { component: string, settings: DefaultAppSetting[] }[] = [];

  defaultAppSettingsForm!: FormGroup;

  constructor(
    private defaultAppSettingService: DefaultAppSettingService,
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private fullSpinnerService: FullSpinnerService) {
    fullSpinnerService.spinner(undefined);

  }
  ngOnInit(): void {
    this.find();
  }
  find() {
    this.fullSpinnerService.spinner('');
    this.defaultAppSettingService.find().subscribe({
      next: (res) => {
        this.defaultAppSettings = res;
        this.groupedDefaultAppSettings = this.groupByComponent(res);
        let objLists: any = {};
        res.forEach((setting, _) => {
          if (setting.required && setting.validationRegex)
            objLists[setting.keyId!] = [this.computeSettingValue(setting), [Validators.required, Validators.pattern(setting.validationRegex)]];

          else if (setting.required)
            objLists[setting.keyId!] = [this.computeSettingValue(setting), [Validators.required]];
          else if (setting.validationRegex)
            objLists[setting.keyId!] = [this.computeSettingValue(setting), [Validators.pattern(setting.validationRegex)]];
          else
            objLists[setting.keyId!] = [this.computeSettingValue(setting), []];

        });
        this.defaultAppSettingsForm = this.formBuilder.group(objLists);

      }, complete: () => {
        this.fullSpinnerService.spinner(undefined);
      }
      , error: () => {
        this.fullSpinnerService.spinner(undefined);
      }
    });
  }
  private groupByComponent(defaultAppSettings: DefaultAppSetting[]): { component: string, settings: DefaultAppSetting[] }[] {
    const groups: { component: string, settings: DefaultAppSetting[] }[] = [];
    defaultAppSettings.forEach((setting) => {
      const component = setting.component || 'Generale';
      let group = groups.find(g => g.component === component);
      if (!group) {
        group = { component, settings: [] };
        groups.push(group);
      }
      group.settings.push(setting);
    });
    return groups;
  }

  computeComponentLabel(component: string): string {
    return AppEnums.appSettingComponentTypes.find(c => c.id === component)?.description || component;
  }

  private computeSettingValue(defaultAppSetting: DefaultAppSetting) {
    if (defaultAppSetting.type === "boolean") {
      if (defaultAppSetting.value && defaultAppSetting.value === "true")
        return true;
      else if (defaultAppSetting.value && defaultAppSetting.value === "false")
        return false;

      else return false;
    }
    return defaultAppSetting.value;
  }

  onSave() {
    if (this.defaultAppSettingsForm.valid) {
      this.fullSpinnerService.spinner('');
      this.defaultAppSettings.forEach((setting) => {
        setting.value = this.defaultAppSettingsForm.controls[setting.keyId!].value;
      });

      this.defaultAppSettingService.save(this.defaultAppSettings).subscribe({
        next: (res) => {
          this.alertService.addErrors(AppConstants.titleSuccessMessage, [AppConstants.successMessage], true);
          this.find();
        }, complete: () => {
        }
        , error: () => {
          this.alertService.addErrors(AppConstants.titleErrorMessage, [AppConstants.errorMessage], true);
          this.fullSpinnerService.spinner(undefined);
        }
      });
    }
  }
}
